// Author Liang Gang Qiang
// Date 2021-11-16 16:17:09

import * as model from "@/model/sithMes/inventory/SithMesInventoryOutdoorProductCategoryModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryOutdoorProductCategory(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
    })
    .buildStore()
